import { Helmet } from "react-helmet-async";
import { BACKEND_URL } from "../lib/site";

const SITE_NAME = "Niharika Patel";
const DEFAULT_DESC = "Growth & Marketing Consultant with ~10 years across Amazon, Nestle, Zepto, Dabur and Emami. Advising B2C startups on integrated growth — brand, performance, and CRM as one system.";
const SITE_URL = BACKEND_URL;

// JSON-LD: Person schema for Niharika (used on homepage & about)
export const personSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Niharika Patel",
  "jobTitle": "Growth & Marketing Consultant",
  "description": DEFAULT_DESC,
  "url": SITE_URL,
  "sameAs": [
    "https://www.linkedin.com/in/niharika-patel-04b1b4140/"
  ],
  "knowsAbout": [
    "Brand Strategy", "Growth Marketing", "Performance Marketing",
    "CRM", "D2C", "E-commerce", "Media Mix Modeling", "CAC/CLTV"
  ],
  "alumniOf": [
    { "@type": "Organization", "name": "Amazon India" },
    { "@type": "Organization", "name": "Nestlé India" },
    { "@type": "Organization", "name": "Zepto" },
    { "@type": "Organization", "name": "Dabur India" },
    { "@type": "Organization", "name": "Emami Ltd." }
  ]
};

// JSON-LD: Website schema
export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": SITE_NAME,
  "url": SITE_URL,
  "description": DEFAULT_DESC,
  "author": { "@type": "Person", "name": "Niharika Patel" }
};

export default function SEOHead({
  title,
  description,
  image,
  url,
  type = "website",
  schema,
  noIndex = false,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Growth & Marketing Consultant`;
  const desc = description || DEFAULT_DESC;
  const canonical = url || SITE_URL;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content={noIndex ? "noindex, nofollow" : "index, follow"} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      {image && <meta property="og:image" content={image} />}
      {image && <meta property="og:image:width" content="1200" />}
      {image && <meta property="og:image:height" content="630" />}

      {/* Twitter Card */}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}

      {/* JSON-LD structured data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(Array.isArray(schema) ? schema : [schema])}
        </script>
      )}
    </Helmet>
  );
}
